import React, { Component } from 'react';
import { PrimaryButton } from '../base-components';
import { connect } from 'react-redux';
import { auth as actions } from '../actions';
import { Signup, Login } from '../components';
import { hashHistory } from 'react-router';

@connect((state) => ({
  authData: state.auth,
  sessionData: state.session
}))

export default class Auth extends Component {
  
  componentDidMount() {
    this.redirectAfterAuth(this.props);
  }
  
  componentWillReceiveProps(nextProps) {
    this.redirectAfterAuth(nextProps);
  }

  redirectAfterAuth(props) {
    if ( props.sessionData.get('sessionToken') ) {
      const state = props.location.state;
      hashHistory.push( state && state.nextPathname || '/patients');
    }
  }
  
  render() {
    const { authData, location } = this.props;
    const account = authData.get('account');
    const route = location.pathname.split('/').slice(-1)[0];
    
    if ( route === 'signup') {
      return (
        <Signup account={account}
                onUpdateAccount={this.onUpdateAccount}
                onSignup={this.onSignup} />
      );
    } else if ( route === 'login' ) {
      return (
        <Login account={account}
               onUpdateAccount={this.onUpdateAccount}
               onLogin={this.onLogin} />
      );
    }
    return null;
  }

  onUpdateAccount = (account) => {
    const { dispatch } = this.props;
    dispatch(actions.onUpdateAccount(account));
  };
  
  onSignup = (account) => {
    const { dispatch } = this.props;
    dispatch(actions.signup(
      account.get('emailAddress'),
      account.get('password'),
      account.get('accessCode')
    ));
  };

  onLogin = (account) => {
    const { dispatch } = this.props;
    dispatch(actions.login(
      account.get('emailAddress'),
      account.get('password')
    ));
  };
}



// WEBPACK FOOTER //
// ./src/pages/auth.js